// extracted by mini-css-extract-plugin
module.exports = {"dualFlags":"fce3","primaryFlag":"zInZ","secondaryFlag":"Zbby"};